import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { RankingDetailOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { BulkModStatusControl } from '@/components/user_catalog/BulkModStatusControl';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { RANKING_DEFAULT_TAB, RANKING_SHOW_TABS } from '../constants';
import { RankingShowHeader } from './RankingShowHeader';
import { RankingGeneralTab } from './RankingGeneralTab';
import { RankingCollectionTab } from './RankingCollectionTab';
import { SearchPopularityCard } from '@/components/common/show/SearchPopularityCard';
import { CollectionPublicationsTable } from '@/components/user_catalog/collections/CollectionPublicationsTable';

export const RankingShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<RankingDetailOut>({
    resource: 'user_catalog.rankings',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('user_catalog.rankings', record?.name);

  const [activeTab, onTabChange] = useShowTab(
    RANKING_SHOW_TABS,
    RANKING_DEFAULT_TAB
  );

  return (
    <Show
      isLoading={isLoading}
      contentProps={bareShowContentProps}
      headerButtons={({ defaultButtons }) => (
        <>
          {record?.id != null && (
            <BulkModStatusControl
              resource="user_catalog.rankings"
              ids={[record.id]}
              onSuccess={() => query.refetch()}
            />
          )}
          {defaultButtons}
        </>
      )}
    >
      {record && (
        <>
          <RankingShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && <RankingGeneralTab record={record} />}
            {activeTab === 'publications' && (
              <CollectionPublicationsTable
                collectionId={record.id}
                collectionKind={record.collection_kind}
              />
            )}
            {activeTab === 'collection' && (
              <RankingCollectionTab record={record} />
            )}
            {activeTab === 'search' && (
              <SearchPopularityCard value={record.search_popularity} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
